import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import TransacaoService from "service/suprimentos/TransacaoService";
import { ListMatchModeOptions, TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const transacaoService = new TransacaoService();

export default function TransacaoListagem() {

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        descricao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        tipo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const tipoFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={transacaoService.getTipoTransacaoFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    return (

        <BaseListagem ordenacao="descricao,ASC" service={transacaoService} urlService="/transacao" tituloPagina={'Transação'} defaultFilters={defaultFilters} showClearFilterButton>
            <Column 
                field="codigo" header="Código" style={{ width: '10em' }} 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                field="descricao" header="Descrição" 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                field="tipo" body={(rowData)=>transacaoService.getTipoTransacao(rowData.tipo)}
                header="Tipo" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={tipoFilterTemplate}
            />
        </BaseListagem>
    )
}
